import { Controller } from "@hotwired/stimulus"

// PSD2 account picker (spec §4): caps the selection at the plan's free
// capacity. Once `max` boxes are checked the unchecked ones are disabled, and
// the submit button follows the count. The server re-checks in
// Bank::ConnectionsController#link_accounts — this is guidance, not the gate.
export default class extends Controller {
  static targets = ["checkbox", "submit"]
  static values = { max: { type: Number, default: 0 }, unlimited: { type: Boolean, default: false } }

  connect() {
    this.update()
  }

  update() {
    const checked = this.checkboxTargets.filter((box) => box.checked).length
    const full = !this.unlimitedValue && checked >= this.maxValue
    for (const box of this.checkboxTargets) {
      if (!box.checked) box.disabled = full
    }
    if (this.hasSubmitTarget) this.submitTarget.disabled = checked === 0
  }
}
